document.addEventListener('DOMContentLoaded', () => {
    // Select all <em><strong></strong></em> elements
    const emStrongElements = document.querySelectorAll('em > strong');

    emStrongElements.forEach(strongElement => {
        // Replace <em> with its child <strong>
        const emElement = strongElement.parentElement; // Get the <em> parent
        emElement.replaceWith(strongElement); // Replace <em> with <strong>
        strongElement.style.color = '#faca00'; // Apply the color
    });
});
